import { css } from "theme/default/css";

export const setFlexFDC = css`
  flex-direction: column;
`;
